import type { Row } from '@tanstack/react-table';
import { Badge, Tooltip } from '@ksyos/design-system';
import type { OrganizationDataError } from '@common/interfaces/api/organizationDataErrorsApi';
import { getSelectedLanguage } from '@frontend/translate';

type ErrorTypeCellProps = {
    row: Row<OrganizationDataError>;
};

export default function ErrorTypeCell({ row }: Readonly<ErrorTypeCellProps>) {
    const translate = getSelectedLanguage();

    return (
        <Tooltip content={translate.organizationDataErrorType.tooltips[row.original.type]}>
            <Badge
                color="orange"
                text={translate.organizationDataErrorType[row.original.type]}
            />
        </Tooltip>
    );
}
